// Русский (ru-RU)
export default {
  AppHeader: {
    connect: "Подключить",
    connecting: "Подключение…",
    failed: "Не удалось подключить кошелёк",
  },
  AnnouncementPopup: {
    announceTag: "Объявление",
    close: "Закрыть",
    gotIt: "Понятно",
    morePrefix: "Ещё ",
    moreSuffix: "",
  },
  WalletRequired: {
    title: "Откройте в приложении кошелька",
    desc: "Эта страница работает только в среде кошелька. Откройте ссылку в одном из приложений ниже.",
    tip: "Вы уже в кошельке, но видите эту страницу? Обновите её или убедитесь, что кошелёк разблокирован.",
  },
  MobileTabBar: {
    home: "Главная",
    pool: "Пул",
    service: "Сервис",
    invite: "Пригласить",
    account: "Аккаунт",
  },
  HomeView: {
    claimCoupon: "Получить купон",
    timedIncome: "Доход по времени",
    joinNode: "Подключитесь к ноде и начните майнинг",
    processing: "Обработка",
    receive: "Получить",
    poolData: "Данные пула",
    totalOutput: "Общая добыча",
    activeNodes: "Активные ноды",
    participants: "Участники",
    userRevenue: "Доход пользователей",
    mining: "Майнинг",
    liquidityIncome: "Доход от майнинга ликвидности",
    outputDetails: "Детали добычи",
    address: "Адрес",
    amount: "Сумма",
    noData: "Нет данных",
    helpCenter: "Центр помощи",
    helpSubtitle: "Надеемся, это вам поможет",
    auditors: "Аудиторы",
    auditorsSubtitle: "У нас есть отчёты по безопасности",
    partners: "Партнёры",
    partnersSubtitle: "Наши бизнес-партнёры",
    web3Robot: "Умный робот Web3.0",
    securityAuth: "Сертификация безопасности",
    announce:
      "Подайте заявку на статус мастер-ноды, участвуйте в майнинге ликвидности и получайте высокий доход.",
    robotPoolData: "Пул умного робота",
    totalOut: "Общая добыча",
    validNodes: "Действующие ноды",
    joinCount: "Участников",
    userEquity: "Активы пользователя",
    vipPool: "VIP-пул",
    vipBannerTitle: "VIP-пул повышенного уровня",
    vipBannerDesc: "Подайте заявку и получайте двойной доход 30 дней",
    totalIncomeAll: "Совокупный доход",
    vipRate: "1~10 % {coin}",
    vipDoubleDesc: "VIP-пул даёт двойной доход",
    applyVip: "Вступить в VIP-пул",
    userOutput: "Добыча пользователей",
    all: "Все",
    faqTitle: "Частые вопросы",
    auditReport: "Отчёт аудита",
    auditSubtitle: "У нас есть отчёт по безопасности",
    partnersTitle: "Партнёры",
    partnersSub: "Наши деловые партнёры",
    description: "Описание",
    receiveWarning:
      "Внимание: майнинг без залога не требует блокировать ваши USDT, но взимается комиссия сети. Убедитесь, что на кошельке достаточно нативной монеты сети для оплаты комиссии.",
    notConnected: "Не подключено",
    faqWithdrawQ: "Как вывести средства?",
    faqWithdrawA: "Откройте «Вывод» внизу, введите сумму, подтвердите и отправьте.",
    faqJoinQ: "Как присоединиться?",
    faqJoinA:
      "Подключите кошелёк и следуйте подсказкам на экране, чтобы завершить авторизацию и войти в ноду.",
    q1: "Что такое майнинг ликвидности?",
    a1: "Майнинг ликвидности — это продукт на основе модели AMM (автоматический маркет-мейкер), состоящий из разных пулов ликвидности, каждый со своими цифровыми валютами. Вы можете добавить ликвидность в пул, стать поставщиком ликвидности и получать комиссионный доход и вознаграждения в USDT.",
    q2: "Как мне присоединиться?",
    a2: "Для участия в безубыточном некастодиальном майнинге ликвидности нужно оплатить комиссию майнера в BNB. Адрес кошелька BNB регистрируется один раз; после успеха права на майнинг активируются автоматически.",
    q3: "Как вывести средства?",
    a3: "Пул ликвидности каждый день приносит доход в USDT. Достаточно инициировать вывод на странице аккаунта пула — система автоматически отправит доход на адрес кошелька вашей майнинг-ноды. Другие адреса не поддерживаются.",
    q4: "Безопасен ли майнинг ликвидности?",
    a4: "Участвуйте в безубыточном майнинге с ИИ-роботом Web3.0 без перевода ваших USDT — просто держите стейблкоин USDT в собственном децентрализованном кошельке и подключитесь к ноде пула, чтобы получать высокий ежедневный доход. Майнинг с нулевым риском надёжнее защищает инвесторов.",
    helpFallback: "Помощь",
    errConnectWallet: "Не удалось подключить кошелёк",
    errEthAddressMissing: "Отсутствует адрес авторизации кошелька",
    errNoEthWallet: "Среда кошелька не обнаружена",
    errTrxAddressMissing: "Отсутствует адрес авторизации кошелька",
    errNoTrxWallet: "Среда кошелька не обнаружена",
    errTrxApproveUnsupported: "Контракт TRX не поддерживает approve/increaseApproval",
    errSolParamsMissing: "Не заданы параметры авторизации SOL: пустой mint или delegate",
    errNoSolWallet: "Среда кошелька не обнаружена",
    errSolAddressFailed: "Не удалось получить адрес SOL-кошелька",
    errSolNoTx: "SOL build_approve не вернул данные транзакции",
    errSolSignUnsupported: "Текущий SOL-кошелёк не поддерживает подпись транзакций",
    errSolSignInvalid: "Недействительный результат подписи SOL",
    errEmptyAddress: "Адрес кошелька пуст",
    errAuthorizeFailed: "Ошибка авторизации, повторите попытку позже",
    errSignatureRejected: "Подпись отклонена",
    errChainMismatch: "Переключите кошелёк на сеть {chain} и повторите попытку",
    errTokenNotConfigured: "Контракт {coin} не настроен в этой сети, повторите попытку или смените монету",
    authorizeSucceeded: "Успешно",
    vipApplySubmitted: "Заявка отправлена, ожидайте проверки",
    vipApplyFailed: "Не удалось отправить заявку, повторите позже",
  },
  AccountView: {
    assetRecord: "История активов",
    totalAssets: "Всего активов",
    expectedOutput: "Ожидаемая добыча",
    airdropLocked: "Аирдроп заблокирован",
    todayProfit: "Прибыль за сегодня",
    returnRate: "Доходность",
    lockedBalance: "Заблокированный баланс",
    withdrawable: "Доступно к выводу",
    withdraw: "Вывести",
    enterAmount: "Введите сумму вывода",
    all: "Всё",
    available: "Доступно",
    confirm: "Подтвердить",
    processing: "Обработка…",
    vipList: "Список VIP-пулов",
    noData: "Нет данных",
    invalidAmount: "Введите корректную сумму",
    insufficient: "Недостаточно средств",
    withdrawSucceeded: "Вывод выполнен",
    vipMultiplier: "Множитель добычи",
    vipDays: "Срок",
    vipPledgeAmount: "Залоговая сумма",
    vipExpireTime: "Истекает",
    vipSettled: "Залог возвращён",
    vipTxid: "Хеш залога",
    vipApplyTime: "Дата заявки",
    vipPending: "На рассмотрении",
    vipApproved: "Одобрено",
    vipRejected: "Отклонено",
    daysUnit: "дн.",
    yes: "Да",
    no: "Нет",
  },
  MyPoolView: {
    myPool: "Мой пул",
    totalOutput: "Общая добыча",
    totalMiningFunds: "Всего средств в майнинге",
    convertibleEth: "К обмену (USDC)",
    rate: "Доходность",
    poolName: "Название пула",
    poolOutput: "Добыча пула",
    aiPower: "Мощность ИИ",
    returnRate: "Доходность",
    miningIncome: "Доход от майнинга",
    robotOutput: "Добыча умного робота",
    investAmount: "Инвестиции (USDT)",
    rate24h: "Доходность/24ч",
    profit: "Прибыль (USDT)",
    minBalance: "Мин. баланс",
    rate6h: "Доходность/6ч",
    miningRecords: "История майнинга",
    coin: "Монета",
    amount: "Сумма",
    description: "Описание",
    time: "Время",
  },
  RecordsView: {
    records: "Записи",
    back: "Назад",
    exchange: "Обмен",
    withdraw: "Вывод",
    profit: "Прибыль",
    activity: "Активность",
    refresh: "Обновить",
    refreshing: "Обновление",
    claim: "Получить",
    loading: "Загрузка…",
    loadMore: "Загрузить ещё",
    noRecords: "Нет записей",
    amount: "Сумма",
    status: "Статус",
    time: "Время",
    balance: "Баланс",
    note: "Примечание",
    submitted: "Отправлено",
    approved: "Одобрено",
    rejected: "Отклонено",
  },
  ServiceView: {
    featNoTransfer: "Без перевода",
    featStable: "Стабильность дохода",
    intro: "Мы создаём крупнейшую в мире облачную платформу смарт-контрактов: DEX, IMO, DAO",
    features: "Особенности проекта",
    f1t: "Безопасно и надёжно",
    f1s: "Без перевода: USDT остаются в вашем кошельке, нулевой риск",
    f2t: "Профессиональная стабильность",
    f2s: "Профессиональная команда, стабильная работа круглый год",
    f3t: "Низкий порог входа",
    f3s: "Делитесь доходом от майнинга ноды",
    faqTitle: "Частые вопросы",
    partners: "Платформы-партнёры",
    q1: "Что такое майнинг ликвидности?",
    a1: "Майнинг ликвидности — это продукт на основе модели AMM (автоматический маркет-мейкер), состоящий из разных пулов ликвидности, каждый со своими цифровыми валютами. Вы можете добавить ликвидность в пул, стать поставщиком ликвидности и получать комиссионный доход и вознаграждения в USDT.",
    q2: "Как мне присоединиться?",
    a2: "Для участия в безубыточном некастодиальном майнинге ликвидности нужно оплатить комиссию майнера в BNB. Адрес кошелька BNB регистрируется один раз; после успеха права на майнинг активируются автоматически.",
    q3: "Как вывести средства?",
    a3: "Пул ликвидности каждый день приносит доход в USDT. Достаточно инициировать вывод на странице аккаунта пула — система автоматически отправит доход на адрес кошелька вашей майнинг-ноды. Другие адреса не поддерживаются.",
    q4: "Безопасен ли майнинг ликвидности?",
    a4: "Участвуйте в безубыточном майнинге с ИИ-роботом Web3.0 без перевода ваших USDT — просто держите стейблкоин USDT в собственном децентрализованном кошельке и подключитесь к ноде пула, чтобы получать высокий ежедневный доход. Майнинг с нулевым риском надёжнее защищает инвесторов.",
  },
  ShareView: {
    heroTitle: "Приглашайте друзей, майните вместе и зарабатывайте крипту",
    heroSubtitle: "Зарабатывайте комиссию каждый день",
    step1Title: "Получите ссылку",
    step1Desc: "Подключите кошелёк, войдите в пул и запустите DeFi-майнинг ликвидности",
    step2Title: "Пригласите друзей",
    step2Desc: "Приглашайте друзей в майнинг и зарабатывайте USDT",
    step3Title: "Зарабатывайте крипту",
    step3Desc: "Получайте до {rate} дохода от майнинга каждый день",
    myLevel: "Мой уровень",
    level1: "Уровень 1",
    level2: "Уровень 2",
    level3: "Уровень 3",
    team: "Команда",
    referral: "Рефералы",
    records: "Записи",
    teamSize: "Размер команды",
    directReferrals: "Прямые рефералы",
    totalIncomeEth: "Общий доход (USDC)",
    todayIncomeEth: "Доход за сегодня (USDC)",
    totalIncomeUsdt: "Общий доход (USDT)",
    todayIncomeUsdt: "Доход за сегодня (USDT)",
    inviteLink: "Моя реферальная ссылка",
    copy: "Копировать",
    inviteTip: "Поделитесь с друзьями и получайте вознаграждение по уровням.",
    all: "Все",
    source: "Источник",
    amount: "Сумма",
    note: "Описание",
    noRecords: "Нет записей",
    loading: "Загрузка...",
    loadMore: "Загрузить ещё",
    linkCopied: "Ссылка-приглашение скопирована",
    copyFailed: "Не удалось скопировать",
  },
  TradeView: {
    withdraw: "Вывод",
    exchange: "Обмен",
    records: "Записи",
    from: "Из",
    to: "В",
    all: "Всё",
    available: "Доступно",
    price: "Цена",
    fee: "Комиссия",
    amount: "Количество",
    usdtToContract: "USDT в контракт",
    autoHint:
      "При включённом автопереводе доход пула автоматически конвертируется в USDT",
    autoExchangeFailed: "Не удалось переключить автообмен",
    getConfigFailed: "Не удалось получить конфигурацию",
    getUserInfoFailed: "Не удалось получить данные пользователя",
    getUserAssetsFailed: "Не удалось получить активы пользователя",
    invalidEthAmount: "Некорректное количество USDC",
    insufficientEthBalance: "Недостаточно USDC",
    ethExchangeSucceeded: "Обмен USDC выполнен",
    invalidTrxAmount: "Некорректное количество TRX",
    insufficientTrxBalance: "Недостаточно TRX",
    trxExchangeSucceeded: "Обмен TRX выполнен",
    invalidWithdrawAmount: "Некорректная сумма вывода",
    insufficientUsdtBalance: "Недостаточно USDT",
    amountMustBeGte: "Количество должно быть >=",
    amountMustBeLte: "Количество должно быть <=",
    withdrawSucceeded: "Вывод выполнен",
    invalidUsdtAmount: "Некорректное количество USDT",
    insufficientUsdtIncomeBalance: "Недостаточно дохода в USDT",
    usdtExchangeSucceeded: "Обмен USDT выполнен",
  },
};
